export default __webpack_public_path__ + "static/media/My Pink Valentine wreath.f950cb7d.jpg";